/*
  Judge.me product review widget: the "minimal header" shows the average as a number only ("4.7  144 reviews").
  We draw five stars in front of it with CSS (see joyvo-reviews.css); this script only reads the number and tells the CSS how
  much of the five stars to fill (--jv-fill), and keeps doing it when the widget redraws itself.
*/
(() => {
  /* The star line under the social proof links to "#judgeme_product_reviews". Judge.me's own script also reacts to that link and scrolls the
     reviews 30px from the top of the screen, which hides the heading under our sticky header. We take the click first and scroll with the
     margin set in CSS (scroll-margin-top), smoothly unless the visitor asked for less motion. */
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href="#judgeme_product_reviews"]');
    if (!link) return;
    const target = document.querySelector('#judgeme_product_reviews');
    if (!target) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'start' });
    history.replaceState(null, '', '#judgeme_product_reviews');
  }, true);

  /* "Write a review" pop-up: on the thank-you step Judge.me leaves only the "Close" pill. We add our own round X (same look as the one on the other steps,
     see joyvo-reviews.css) that presses that pill, so the top right corner always has a close button. */
  const addCloseX = () => {
    const modal = document.querySelector('.jdgm-write-review-modal');
    const content = modal && modal.querySelector('.jdgm-write-review-modal__content');
    if (!content || content.querySelector('.jv-modal-x')) return;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'jdgm-write-review-modal__close-btn jv-modal-x';
    button.setAttribute('aria-label', 'Close review form');
    button.addEventListener('click', () => {
      const close = modal.querySelector('.jdgm-write-review-modal__nav-btn-close');
      if (close) close.click();
    });
    content.prepend(button);
  };
  new MutationObserver(addCloseX).observe(document.body, { childList: true, subtree: true });

  /* filter menu: Judge.me opens its filter panel in the page flow, which pushes the reviews down. The CSS turns it into a drop-down
     under the filter button; this part tells the CSS where the button is, and closes the menu on a click outside or Escape. */
  const WIDGET = '#judgeme_product_reviews';
  const placePanel = () => {
    const widget = document.querySelector(WIDGET);
    if (!widget) return;
    const header = widget.querySelector('.jm-review-widget__header');
    const button = widget.querySelector('.jm-custom-answer-filter');
    if (!header || !button) return;
    const h = header.getBoundingClientRect();
    const b = button.getBoundingClientRect();
    header.style.setProperty('--jv-panel-top', Math.round(b.bottom - h.top + 12) + 'px');
    header.style.setProperty('--jv-panel-right', Math.max(0, Math.round(h.right - b.right)) + 'px');
  };
  const closeFilter = () => {
    const button = document.querySelector(WIDGET + ' .jm-custom-answer-filter[aria-expanded="true"]');
    if (button) button.click();
  };
  document.addEventListener('click', (event) => {
    if (event.target.closest(WIDGET + ' .jm-filter-panel, ' + WIDGET + ' .jm-custom-answer-filter')) {
      setTimeout(placePanel, 0);
      return;
    }
    closeFilter();
  });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeFilter(); });
  window.addEventListener('resize', placePanel);

  const SELECTOR = '#judgeme_product_reviews .jm-average-rating-display';
  const update = () => {
    document.querySelectorAll(SELECTOR).forEach((el) => {
      const number = parseFloat((el.querySelector('p.jm-text') || {}).textContent);
      if (!isNaN(number)) el.style.setProperty('--jv-fill', Math.max(0, Math.min(100, (number / 5) * 100)) + '%');
    });
  };
  const start = () => {
    update();
    new MutationObserver(update).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
